"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsDataInitialization = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _SendUserAnalyticsData = require("./SendUserAnalyticsData");
var _jsxRuntime = require("react/jsx-runtime");
const AnalyticsDataInitialization = ({
  data: {
    periodCode
  }
}) => {
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi']);
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    formattedToken
  } = (0, _auth.useToken)();
  if (!formattedToken || !tenant) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
    areaName: "AnalyticsDataInitialization",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      baseUrl: globalApiUrl,
      tenant: tenant,
      language: language,
      token: formattedToken,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SendUserAnalyticsData.SendUserAnalyticsData, {
        periodCode: periodCode
      })
    })
  });
};
exports.AnalyticsDataInitialization = AnalyticsDataInitialization;
